import { Component, inject } from '@angular/core';
import { CreatePortAgentComponent } from '../../../dis-repository/pages/create-port-agent/create-port-agent.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, debounceTime } from 'rxjs';
import { PortAgentService } from 'src/app/shared/service/disbursment/port-agent.service';
import { MaPortAgent } from '../../../dis-repository/pages/create-port-agent/port-agent.model';
import { ToastrService } from 'ngx-toastr';
import { DisbursmentService } from 'src/app/shared/service/disbursment/disbursment.service';
import { ViewEmailsComponent } from '../../../dis-repository/pages/create-port-agent/view-emails/view-emails.component';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-port-agent',
  templateUrl: './port-agent.component.html',
  styleUrls: ['./port-agent.component.scss']
})
export class PortAgentComponent {
 constructor(
    private loaderService: DisbursmentService,
    private portAgentService: PortAgentService,
    private snackBar: ToastrService,
    private dialog: MatDialog,
    private requestFormService: RequestFormService,
  ) { }

 private loader = inject(DisbursmentService);
 isLoading$ = this.loader.loading$;
  searchTerm = '';
  displayedColumns = ['Sl.No', 'company_name', 'Action'];
  dataSource = new MatTableDataSource<MaPortAgent>();
  currentPage = 1;
  pageSize = 50;
  allDataLoaded = false;
  totalCount = 0;
  private searchSubject = new Subject<string>();


  ngOnInit() {
    this.getMaPortAgentDataFromDb(true);

    // Setup debounce for search
    this.searchSubject
      .pipe(
        debounceTime(1000)
      )
      .subscribe(() => {
        this.onSearch();
      });
  }

  ngOnDestroy() {
    this.searchSubject.complete();
  }

  inputSearch(): void {
    if (this.searchTerm.trim() === '') {
      this.onSearch();
    } else {
      this.searchSubject.next(this.searchTerm);
    }
  }

  //method to filter the records from db
  onSearch(): void {
    this.getMaPortAgentDataFromDb(true);
  }

  //method to clear the searchTerm
  clearSearch() {
    this.searchTerm = '';
    this.getMaPortAgentDataFromDb(true);
    this.dataSource.filter = '';
  }

  //method to call an api on scroll
  onManualScroll(): void {
    const scrollContainer = document.querySelector('.table-container');

    if (scrollContainer) {
      const scrollPosition = scrollContainer.scrollTop + scrollContainer.clientHeight;
      const scrollHeight = scrollContainer.scrollHeight;

      if (
        scrollPosition >= scrollHeight - 10 &&
        !this.loaderService.loading$ &&
        !this.allDataLoaded
      ) {
        this.getMaPortAgentDataFromDb();
      }
      if (this.totalCount && this.dataSource.data.length >= this.totalCount) {
        this.allDataLoaded = true;
        return;
      }
    }
  }

  // method to fetch the port-agent list from db
  getMaPortAgentDataFromDb(reset = false) {
    if (reset) {
      this.currentPage = 1;
      this.allDataLoaded = false;
      this.dataSource.data = [];
      this.totalCount = 0;
    }

    const body = {
      page: this.currentPage,
      page_size: this.pageSize,
      query: this.searchTerm.trim(),
      status: 'Y'
    };

    this.loaderService.show();

    this.portAgentService.portAgentDataFromDb(body).subscribe({
      next: (response: { data: MaPortAgent[]; total_count: number }) => {
        const newData = response.data;

        this.totalCount = response.total_count;

        this.dataSource.data = [...this.dataSource.data, ...newData];

        if (this.dataSource.data.length >= this.totalCount) {
          this.allDataLoaded = true;
        }

        this.currentPage++;
        this.loaderService.hide();
      },
      error: (error) => {
        const errorMsg = error?.detail;
        this.snackBar.error(errorMsg || 'Something went wrong. Please try again later.');
        this.loaderService.hide();
      }
    });
  }



  // method to open the portagent add diaolg
  openAddPortAgentDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { right: '0' };
    dialogConfig.height = '100%';
    dialogConfig.width = '66vw';
    dialogConfig.panelClass = ['animate__animated', 'animate__slideInRight'];

    const dialogRef = this.dialog.open(CreatePortAgentComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'refresh') this.getMaPortAgentDataFromDb(true);
    });
  }

  openEditPortAgentDialog(rowData: MaPortAgent) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { right: '0' };
    dialogConfig.height = '100%';
    dialogConfig.width = '66vw';
    dialogConfig.data = { rowData };
    dialogConfig.panelClass = ['animate__animated', 'animate__slideInRight'];

    const dialogRef = this.dialog.open(CreatePortAgentComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'refresh') this.getMaPortAgentDataFromDb(true);
    });
  }


  openDialog(rowData: any) {
    this.dialog.open(ViewEmailsComponent, {
      data: rowData,
      width: '500px',
      height: '80vh'
    });
  }
   isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
}
